import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    CircularProgress,
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: "2%",
        margin: "2%"
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    }
});

const HeadphoneProductEditForm = props => {
    const { classes, formSettings, editable, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(true);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                name="OperatingSystemVersion"
                                value={values.OperatingSystemVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OperatingSystemVersion && touched.OperatingSystemVersion)}
                                placeholder={translations['operating_system_version'] || 'Operating system version'}
                                label={translations['operating_system_version'] || 'Operating system version'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ReleaseYear"
                                value={values.ReleaseYear}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ReleaseYear && touched.ReleaseYear)}
                                placeholder={translations['release_year'] || 'Release year'}
                                label={translations['release_year'] || 'Release year'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="DeviceColor"
                                value={values.DeviceColor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.DeviceColor && touched.DeviceColor)}
                                placeholder={translations['device_color'] || 'Device color'}
                                label={translations['device_color'] || 'Device color'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ProductIdentifier"
                                value={values.ProductIdentifier}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ProductIdentifier && touched.ProductIdentifier)}
                                placeholder={translations['product_identifier'] || 'Product identifier'}
                                label={translations['product_identifier'] || 'Product identifier'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ANumber"
                                value={values.ANumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ANumber && touched.ANumber)}
                                placeholder={translations['a_number'] || 'ANumber'}
                                label={translations['a_number'] || 'ANumber'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="OemStatus"
                                value={values.OemStatus}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OemStatus && touched.OemStatus)}
                                placeholder={translations['oem_status'] || 'Oem status'}
                                label={translations['oem_status'] || 'Oem status'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="OemReason"
                                value={values.OemReason}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OemReason && touched.OemReason)}
                                placeholder={translations['oem_reason'] || 'Oem reason'}
                                label={translations['oem_reason'] || 'Oem reason'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SecurazeVersion"
                                value={values.SecurazeVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SecurazeVersion && touched.SecurazeVersion)}
                                placeholder={translations['securaze_version'] || 'Securaze version'}
                                label={translations['securaze_version'] || 'Securaze version'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled
                            />
                            <TextField
                                name="HardwareID"
                                value={values.HardwareID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.HardwareID && touched.HardwareID)}
                                placeholder={translations['hardware_id'] || 'HardwareID'}
                                label={translations['hardware_id'] || 'HardwareID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    style={{ width: '100%' }}
                                    type="submit"
                                    disabled={!(isValid && dirty) || isSubmitting || !editable}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(HeadphoneProductEditForm);
